<div
  [class]="'product-detail-cards-quantity ' + customClasses"
  *ngIf="!isCard && product; else cardButton"
>
  <div
    class="detail-cards-quantity-content"
    [class.product-detail-cards-quantity__clear]="customClasses === 'clear'"
    [ngClass]="{'center-input': !product?.totalStock || isSampling, 'mobile': isMobile }"
  >
    <a
      [class.detail-cards-quantity-control__clear]="customClasses === 'clear'"
      [id]="idPrefix + 'remove-quantity-' + product.id"
      class="detail-cards-quantity-control"
      [class.disabled]="(model.quantity === 1 && !removeItemInOne) || product.coupon"
      (click)="remove()"
      *ngIf="shouldShowQuantityControls()"
    >
      <span>-</span>
    </a>

    <input
      [class.detail-cards-quantity-control__clear]="customClasses === 'clear'"
      [id]="idPrefix + 'input-quantity-' + index + '-' + product.id"
      class="detail-cards-quantity-number"
      [(ngModel)]="model.quantity"
      (ngModelChange)="input()"
      [disabled]="disableInputQuantity()"
    />

    <a
      [id]="idPrefix + 'add-quantity-' + product.id"
      class="detail-cards-quantity-control"
      [class.detail-cards-quantity-control__clear]="customClasses === 'clear'"
      [class.disabled]="disableAddQuantity()"
      (click)="add(product?.objectID || product?.id + '26')"
      *ngIf="shouldShowQuantityControls()"
    >
      <span>+</span>
    </a>
  </div>
</div>

<ng-template #cardButton>
  <app-button
    class="icon-plus app-button__icon-plus"
    [buttonId]="idPrefix + 'add-product-button-' + product.id"
    [title]="'Agregar'"
    (click)="add(product?.objectID || product?.id + '26')"
    *ngIf="product && !model.active; else addRemoveButtons"
    [isDisabled]="
      !product.totalStock || product.fullPrice === 0 || !product.fullPrice || isSampling
    "
    [productCuf]="product.id"
    [isLorealDesign]="isLorealDesign || isVTO"
    [class.app-button__icon-plus-mini]="isMiniCard"
    [customClasses]="'app-button__icon-plus main '"
    [isTemplate]="true"
    [isFlashOffer]="isFlashOffer"
  >
  <div *ngIf="model.quantity >0" alt="detail" class="title" class="quantity-detail-marketplace">{{model.quantity}}</div>
  <img *ngIf="model.quantity ==0" src="/assets/svg/sdf-icon-plus.svg" alt="detail" class="icon-plus" id="icon-detail-marketplace">
  </app-button>

  <ng-template #addRemoveButtons>
    <app-button
      *ngIf="product && model.active"
      [buttonId]="idPrefix + 'add-product-button-controls-' + product.id"
      [class.app-button__icon-plus-mini]="isMiniCard"
      [customClasses]="'app-button__quantity-button main xlg '"
      [isTemplate]="true"
      [productCuf]="product.id"
      [isLorealDesign]="isLorealDesign || isVTO"
      [isFlashOffer]="isFlashOffer"
    >
      <span class="quantity-controls">
        <span
          [id]="idPrefix + 'add-product-button-control-remove-' + product.id"
          class="less"
          (click)="remove()"
          ><span class="material-icons icon-minus">-</span></span
        >
        <span
          [id]="idPrefix + 'add-product-button-control-quantity-' + product.id"
          class="quantity"
          >{{ model.quantity }}</span
        >
        <span
          [id]="idPrefix + 'add-product-button-control-more-' + product.id"
          class="more"
          (click)="add(product?.objectID || product.id + '26')"
          ><span class="material-icons">+</span></span
        >
      </span>
    </app-button>
  </ng-template>
</ng-template>
